import React from "react";
import styles from "./badge.module.css";
const Badge = ({ label = "", badgeClassOverride = {},badgeStylesOverride,...Props }) => {
  return (
    <div className={`${styles.badge} ${badgeClassOverride}`} style={badgeStylesOverride} {...Props}>{label}</div>
  );
};

export default React.memo(Badge);
